"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var gtm_1 = require("../../../analytics/gtm");
function default_1($store) {
    var send = lodash_1.curry(gtm_1.sendEvent)('Reisesuche');
    var params = $store.getters['searching/search/params'];
    // Region
    var region = $store.getters['searching/search/selectedRegion'];
    var regionName = region.name;
    if (region.id === null || region.id === 'all') {
        regionName = 'Alle Regionen';
    }
    // Reisezeitraum
    var zeitraum = params.timeFrom + "/" + params.timeTo;
    // duration
    var duration = $store.getters['searching/search/selectedTravelDuration'].name;
    // departure airport
    var airoprt = $store.getters['searching/search/selectedAirport'].name;
    // extra
    var extra = $store.getters['searching/search/selectedExtraFilter'].name;
    // pax group
    var pax = "A" + params.adults + "_J" + params.juveniles + "_C" + params.children;
    /*
      // 1. Event
      eventCategory: Reisesuche
      eventAction: Zielgebiet/Kanaren
      eventLabel: 2017-12-09/2017-12-16
    */
    send("Zielgebiet/" + regionName, zeitraum);
    /*
      // 2. Event
      eventCategory: Reisesuche
      eventAction: Reisetermin
      eventLabel: 2017-12-09/2017-12-16
    */
    send('Reisetermin', zeitraum);
    /*
      // 3. Event
      eventCategory: Reisesuche
      eventAction: Zielgebiet
      eventLabel: Kanaren
    */
    send('Zielgebiet', regionName);
    /*
      // 4. Event
      eventCategory: Reisesuche
      eventAction: Reisende
      eventLabel: A2_J0_C1
    */
    send('Reisende', pax);
    /*
      // 5. Event
      eventCategory: Reisesuche
      eventAction: Abflughafen
      eventLabel: Bremen
    */
    send('Abflughafen', airoprt);
    /*
      // 6. Event
      eventCategory: Reisesuche
      eventAction: Reisedauer
      eventLabel: 1-5 Tage
    */
    send('Reisedauer', duration);
    /*
      // 7. Event
      eventCategory: Reisesuche
      eventAction: Erweitert
      eventLabel: AIDA Vario
    */
    send('Erweitert', extra);
}
exports.default = default_1;
//# sourceMappingURL=trackClickForwardToCruiseDetail.js.map